import { useCurrentProject } from 'providers/LiteProjectProvider';
import React, { useMemo } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import Header from 'views/components/Header';
import PhasesHeader from 'views/components/Header/PhasesHeader';

const ProjectDetailViewHeader = ({ user, onChangePhase, onReorderPhases, onOpenPhasesModals }) => {
  const location = useLocation();
  const { selectedPhaseId, project, isTemplate, template } = useCurrentProject();
  const parsedPhases = useMemo(() => project.phases.map((phase) => ({ ...phase, selected: phase.id.value === selectedPhaseId })), [project, selectedPhaseId]);
  const isLiteProject =
    !!matchPath(location.pathname, { path: '/lite/:projectId', exact: true }) ||
    !!matchPath(location.pathname, { path: '/litecallback/:projectId', exact: true });

  return (
    <div>
      <Header project={project} user={user} isTemplate={isTemplate} template={template} />

      {!isLiteProject && (
        <PhasesHeader phases={parsedPhases} onChangePhase={onChangePhase} onReorderPhases={onReorderPhases} onOpenPhasesModals={onOpenPhasesModals} />
      )}
    </div>
  );
};

export default ProjectDetailViewHeader;
